import * as React from "react";
import { JobRequestFile } from "gen/clients";
import { Typography, Tooltip, Box } from "@mui/material";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { downloadJobRequestFile } from "../../utils/JobRequestUtils";
import { StarRating } from "components/StarRating/StarRating";

interface Props {
  jobRequestId: string;
  files: JobRequestFile[];
}

const FileList: React.FC<Props> = ({ jobRequestId, files }) => {
  const onFileLinkClick = React.useCallback(
    async (file: JobRequestFile) => {
      await downloadJobRequestFile(jobRequestId, file);
    },
    [jobRequestId]
  );

  return (
    <Stack spacing={0.5} data-testid="file-list">
      {files.map(f => (
        <Box key={f.id} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="body2">
            <Link href="#" onClick={() => onFileLinkClick(f)}>
              {f.fileName}
            </Link>
          </Typography>
          {f.linguisticQualityScore && (
            <Box sx={{ ml: 1 }}>
              {f.linguisticQualityScoreReason ? (
                <Tooltip title={f.linguisticQualityScoreReason} arrow>
                  <Box>
                    <StarRating rating={f.linguisticQualityScore} size="small" />
                  </Box>
                </Tooltip>
              ) : (
                <StarRating rating={f.linguisticQualityScore} size="small" />
              )}
            </Box>
          )}
        </Box>
      ))}
    </Stack>
  );
};

export { FileList };
